// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const HogarWrapper: StatelessFunctionalComponent<*> = styled.div`
  padding: 20px 10px !important;
  
  .Hogar {
    &-formRow {
      margin-top: 16px;
      display: flex;
      justify-content: center;

      &-1 {
        margin-top: 16px;
        max-width: 450px;
        text-align: center;
        margin: auto !important;
      }
    }

    @media (max-width: 700px){
      &-formRow {
        flex-direction: column;
      }
    }

    &-formRow-2 > * {
      margin: 0 10px;
    }

    &-checks {
      display: grid;
      padding: 10px;
      align-items: center;
      flex-direction: row;

      div p {
        height: 100%;
      }
    }

    &-checks-1 {
      grid-template-columns: 1.5fr 1fr;
    }

    &-checks-2 {
      grid-template-columns: 1fr 1fr;
    }

    &-checks-3 {
      grid-template-columns: 1fr 2fr;
    }

    &-options {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;
      flex-direction: row;

      &-container {
        width: 100%;
      }

      &-check {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        justify-content: center;
        margin: auto 0;
      }

      &-check-3 {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        align-items: center;
        justify-content: center;
        margin: auto 0;
      }

      @media (max-width: 800px){
        &-check-2 {
          margin: 0;
          text-align: right;
          padding-right: 15px;
          grid-template-columns: 1fr;
        }
      }
    }

    @media (max-width: 700px){
      &-options {
        flex-direction: column;
        margin-right: 5%;
      }
    }

    &-option {
      margin: 8px;
      cursor: pointer;
      height: 48px;
      font-size: 2.0em;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-left: 15px;
      text-align: center;
      vertical-align: middle;
      border-radius: 2px;
      box-shadow: 0 7px 6px 0 rgba(0, 0, 0, 0.11), 0 2px 4px 0 rgba(0, 0, 0, 0.09);
      text-transform: uppercase;
      
      &-on {
        color: var(--white-color);
        background-color: var(--blue-color);
      }

      &-off {
        color: var(--white-color);
        background-color: var(--inactive-button);
      }

      &-icon {
        width: 28px;
        height: 28px;
        margin-right: 20px;
      }

      &-text {
        margin-right: 20px;
        color: #525252;
        text-align: left;
      }

      &-check {
        font-size: 16px;
        color: #444;
        margin: 5px;

        label {
          cursor: pointer;
          display: inline-flex;
          align-items: center;
        }

        label span {
          padding-right: 10px;
        }
      }
    }

    &-radioWrapper {
      border: 1px solid rgb(151, 151, 151, .4);
      border-radius: 4px;
      min-width: 26px;
      min-height: 26px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      input {
        opacity: 0;
        position: absolute;
      }

      &--on:after {
        content: '';
        display: block;
        width: 5px;
        height: 12px;
        border: solid var(--blue-light-color);
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        position: relative;
        top: -1px;
      }
    }
  }

  .SelectedAnswers {
    display: flex;
    flex-wrap: wrap;
    grid-gap: 10px;
    margin: 20px 0px;
    justify-content: center;
    grid-auto-flow: column;

    &-answer {
      &-icon {
        margin-right: 5px;
        width: 20px;        
      }

      &-content {
        display: flex;
        flex-direction: row;
        align-items: center;
        vertical-align: middle;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        color: #ffffff;
      }

      &-button {
        padding: 12px;
        font-size: 18px;
        margin: 5px;
        border-radius: 5px;
        white-space: nowrap;
        position: relative;
        cursor: pointer;
        color: var(--white-color);
        background-color: var(--blue-color);
      }

      &-cross {
        position: absolute;
        top: 0px;    
        right: 8px;
        font-size: 12px;
      }
    }
  }

  .SkyBlue {
    &-box {
      border-radius: 3px;
      background-color: #40c3e3;
      box-shadow: 0 7px 6px 0 rgba(0, 0, 0, 0.11), 0 2px 4px 0 rgba(0, 0, 0, 0.09);
      padding: 20px;
      font-size: 85%;
    }

    @media (max-width: 850px){
      &-box {
        padding-left: 15px;
        padding-right: 15px;
      }
    }

    &-text {
      font-size: 2.0em;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;
      margin-bottom: 5px;

      &-bold {
        font-weight: bold;
      }

      &-title {
        font-size: 3.5em;
        font-weight: bold;
      }
    }
  }

  .OptionInfo {
    &-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 40px;
    }

    &-text {
      font-size: 2em;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #525252;
    }

    &-center {
      text-align: center;
    }

    &-icon {
      margin-right: 30px;
      max-width: 60px;
    }

    @media (max-width: 530px){
      &-icon {
        display: none;
      }
    }

    &-options {
      &-container {
        margin: 0 0 18px 0;
        text-align: center;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
      }

      &-option {
        flex: 1;
        margin: 8px;
        cursor: pointer;
        text-align: center;
        display: grid;
        flex-direction: row;
        align-items: center;
        vertical-align: middle;
        border-radius: 3px;
        background-color: var(--blue-color);
        box-shadow: 0 7px 6px 0 rgba(0, 0, 0, 0.11), 0 2px 4px 0 rgba(0, 0, 0, 0.09);
        color: var(--white-color);
        background-color: var(--blue-color);
        font-size: 1.825em;
        padding: .825em;
        min-width: 80px;
      }

      @media (max-width: 758px){
        &-option {
          font-size: 1.6em;
        }
      }
    }
  }
  
  .Price {
    &-title-content {
      background-color: #fff;
      display: flex;
      justify-content: space-around;
      padding: 15px;
      border-bottom: 1px solid #ddd;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      border-left: 3px solid #00aec7;
      border-right: 3px solid #0033a0;
      box-shadow: 0 5px 4px 0 rgba(0, 0, 0, 0.11), 0 1px 2px 0 rgba(0, 0, 0, 0.09);
      
      label {
        text-align: center;
        color: var(--blue-color);
        padding: 5px;
        font-size: 1.8em;
      }
    }

    &-icon-check:after {
      content: '';
      display: block;
      width: 5px;
      height: 12px;
      border: solid var(--blue-light-color);
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
      position: relative;
      top: -1px;
    }

    &-info-line {
      grid-template: "text numb" 
                    / 1fr  80px;
    }
  }
`;

export default HogarWrapper;
